import { getWindow } from '@change-corgi/core/window';

import type { PxParam } from './getPxParamVariableName';
import { getPxParamVariableName } from './getPxParamVariableName';

export function setPxParamVariable(param: PxParam, value: unknown): void {
	getWindow()[getPxParamVariableName(param)] = value;
}
